import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateSubTasks = document.createElement('template');

templateSubTasks.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <header class="page__header">
    <gz-button type="quiet" color="secondary" buttonheight="medium" buttonfontsize="medium" id="btnBack" class="btnBack">
      <i class="ds-icon-arrow_left_collapse"></i>
      <span id='btnBackText'></span>
    </gz-button>
    <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>
  <div class="content">
    <gz-grid-view>
      <div class="header__actions" slot="grid-header-actions-slot">
        <gz-button id="stopBtn" type="quiet" color="secondary" buttonfontsize="medium" disabled></gz-button>
      </div>
    </gz-grid-view>
    <gz-side-menu id="sideMenu" menuwidth="400" resizable="left" closeOnClickOutside></gz-side-menu>
  </div>
`;
